<template>
    <div ref="container">
        <a-modal 
            :title="title" 
            width="95%" 
            :visible="visible" 
            :confirmLoading="confirmLoading" 
            :maskStyle="{'top':'93px','left':'154px'}" 
            :maskClosable="false" 
            @ok="handleOk" 
            @cancel="handleCancel"
            @close="closeModal" 
            cancelText="关闭" 
            style="top:50px;height: 90%;"
        >
            <a-list>
                <a-list-item v-for="(item, index) in scanData" :key="index">
                    <div v-if="item.key"><a style="display:block">{{item.key}}</a>
                        <a-list>
                            <a-list-item v-for="(code, index) in item.value" :key="index">{{ index + 1 }}. {{ code }}</a-list-item>
                        </a-list>
                    </div>
                    <div v-else>{{ index + 1 }}. {{ item }}</div>
                </a-list-item>
            </a-list>
        </a-modal>
    </div>
</template>
<script>
import { getUploadCodeDetails, getUploadExceptionDetails } from '@/api/api'
export default {
    name: '码详情',
    components: {
    },
    data () {
        return {
            title: '出库列表',
            visible: false, 
            detailVisible: false, 
            traceDetailVisible: false, 
            confirmLoading: false,
            originalImageVisible: false,
            originalImageUrl: '',
            processId: '',
            selectedItem: {},
            details: [],
            scanData: [],
            model: {},
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
            },
            listData:[],
            traceDetails:[],
            columns: [
                {
                    title: '序号',
                    dataIndex: '',
                    key:'rowIndex',
                    width: '5%',
                    align:"center",
                    customRender:function (t,r,index) {
                        return parseInt(index)+1;
                        //  return (this.ipagination.current - 1) * this.ipagination.pageSize + index + 1;
                    }
                },
                { title: '单据编号', dataIndex: 'billNo', },
                { title: '扫码数量', dataIndex: 'scanNum', },
                { title: '创建时间', dataIndex: 'createTime', },
                {
                    title: '操作',
                    dataIndex: 'action',
                    width: 150,
                    align:"center",
                    scopedSlots: { customRender: 'action' },
                },
            ],
            ipagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            eventIpagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0,
            },
        }
    },
    computed: {
       
    },
    methods: {
        show(e, type){
            this.visible = true
            console.log(e,'e===================')
            if( type == true ){
                this.getList(e)
            } else {
                this.getErrorList(e)
            }
            
        },
        async getList(e){
            const params = {
                id: e.id,
            }
            const res = await getUploadCodeDetails(params)
            if( res.code == 200 && res.success == true ){
                this.scanData = res.result
            }
        },
        async getErrorList(e){
            const params = {
                id: e.id,
            }
            const res = await getUploadExceptionDetails(params)
            if( res.code == 200 && res.success == true ){
                this.scanData = res.result
            }
        },
        handleOk() {
          this.visible = false;
        },
        handleCancel(){
          this.visible = false;
        },
        closeModal(){
          this.visible = false;
        },
        getCodeOk(){

        },
        getCodeClose(){

        },
        handleEventChange(pagination, filters, sorter) {
            this.eventIpagination.current = pagination.current;
            this.eventIpagination.pageSize = pagination.pageSize;

            // 如果需要处理排序或过滤，可以在这里添加逻辑
            this.getTraceList(this.processId);
        },
        
    }
}
</script>
<style lang="less" scoped>

</style>